const projectsData = [
  {
    title: "Manim Web - Browser-Based Mathematical Animation Editor",
    description: "Manim Web is a browser-based workspace for creating mathematical animations with Python and Manim Community Edition. It lets users write scenes, render and preview the actual output, organize project assets, add audio and captions, and export polished videos without setting up Manim locally.",
    technologies: [
      "Next.js",
      "Python",
      "Manim CE",
      "Video Processing"
    ],
    liveLink: "https://manim.varunrao.com/",
    image: "manim-web.png",
    development_time: "6 Months",
    purpose: "To make professional mathematical animation creation accessible directly from the browser."
  },
  {
    title: "Personal Tuition Manager",
    description: "The Personal Tuition Manager is an application designed to help teachers manage student attendance, payments, and course details. It aims to streamline administrative tasks for educators, enabling them to focus on teaching while keeping track of essential student data in one place. The app operates offline, ensuring data privacy and availability even without an internet connection.",
    technologies: [
      "Flutter",
      "SQLite",
      "State Management",
      "Local Storage"
    ],
    codeLink: "https://github.com/varunrao1991/personal_tuition_manager",
    image: "personal_tuition_manager.webp",
    development_time: "2 Months",
    ai_tools_used: ["ChatGPT"],
    purpose: "To create a comprehensive and offline solution for teachers to manage their students and related tasks."
  },
  {
    title: "AI-Powered Family photo manager",
    description: "The Family Photo Manager is an intelligent, privacy-focused application that helps users organize, search, and manage their personal photo collections using cutting-edge AI technology. Unlike cloud-based solutions, it processes all images locally on your machine, keeping your precious memories private and secure.",
    technologies: [
      "Computer Vision",
      "Multimodal AI",
      "Image Embeddings",
      "Similarity Search"],
    codeLink: "https://github.com/varunrao1991/family_photo_manager",
    image: "family_photo_manager.webp",
    development_time: "3 Weeks",   
    ai_tools_used: ["Deepseek"],
    purpose: "Tool development practice end to end."
  },
  {
    title: "OPENCNN - Neural network inference from scratch",
    description: "OpenCNN is a project designed to deepen understanding of the inner workings of convolutional neural network layers during the inference stage. It replicates and executes the fundamental operations found in CNN architectures — particularly those used in YOLO models up to version 6. The implementation is entirely written in OpenCL, leveraging GPU acceleration through general-purpose GPU (GPGPU) programming to explore performance and architectural behavior at a low level.",
    technologies: [
      "Computer Vision",
      "Image Processing",
      "Inference Optimization",
      "OpenCL"],
    codeLink: "https://github.com/varunrao1991/opencnn",
    image: "opencnn.webp",
    development_time: "4 Months",
    purpose: "Gaining deeper undersatnding of CNNs"
  },
  {
    title: "AI-Generated Face Blurring Tool",
    description: "A rapid prototype face blurring application created entirely through AI-assisted development to experiment with prompt engineering for computer vision tasks. Built in a single session using AI coding tools.",
    technologies: [
      "AI-Assisted Development",
      "Prompt Engineering",
      "OpenCV",
      "PyQt5"
    ],
    codeLink: "https://github.com/varunrao1991/face-blurring-app",
    image: "ai-blur-demo.webp",
    development_time: "2 hours",
    ai_tools_used: ["ChatGPT", "Deepseek", "Gemini"],
    purpose: "Prompt engineering practice"
  }
];

export default projectsData;
